var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.182 9.99993C18.182 14.5187 14.5189 18.1818 10.0002 18.1818C5.48149 18.1818 1.81836 14.5187 1.81836 9.99993C1.81836 5.48124 5.48149 1.81812 10.0002 1.81812C14.5189 1.81812 18.182 5.48124 18.182 9.99993Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63623 6.97906C8.96941 6.6016 9.45687 6.36353 9.99987 6.36353C11.004 6.36353 11.818 7.17755 11.818 8.18171C11.818 9.03052 11.2363 9.74352 10.4498 9.9438C10.2065 10.0057 9.99987 10.2034 9.99987 10.4544V10.909",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.6365H10.0087",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSupport);
export default __webpack_public_path__ + "static/media/profile-support.2ac3bf8e81a18cae54dcee7173b99d53.svg";
export { ForwardRef as ReactComponent };